import { matchPath, useLocation, matchRoutes } from 'react-router-dom';

// CONSTANTS
import { mybundleRoutes, partnerRoutes } from '@/constants/routes';
import { checkIsAbsoluteUrl } from '@/utility/routes';

const routes = mybundleRoutes.concat(partnerRoutes).map(item => ({ path: item }));

export function getMatchPathFromArray(link, array) {
  for (const path of array) {
    const match = matchPath(
      {
        path,
      },
      link,
    );

    if (match) {
      return match;
    }
  }

  return null;
}

export function usePathPattern() {
  const location = useLocation();
  const [{ route }] = matchRoutes(routes, location);

  return route.path;
}

/**
 * Adds query params to existing URLs (inc merging duplicates)
 * @param {string} url - src URL to modify
 * @param {object} params - key/value object of params to add
 * @example
 * // returns /path?tag=api
 * addQueryParamsToUrl('/path?tag=hardware', { tag:'api' })
 * @example
 * // returns https://test.com/path?tag=api
 * addQueryParamsToUrl('https://test.com/path?tag=hardware', { tag: 'api' })
 * @returns {string} modified URL
 */
export function addURLParameter(url, params = {}) {
  if (!url) return '';

  const fakeBase = !checkIsAbsoluteUrl(url) ? 'http://fake-domain.com' : undefined;
  const modifiedUrl = new URL(url || '', fakeBase);

  Object.keys(params).forEach(key => {
    if (modifiedUrl.searchParams.has(key)) {
      modifiedUrl.searchParams.set(key, params[key]);
    } else {
      modifiedUrl.searchParams.append(key, params[key]);
    }
  });

  return modifiedUrl.toString().replace(fakeBase, '');
}

export function removeURLParameter(url, paramKey, replaceUrl = true) {
  const urlIns = new URL(url);

  if (Array.isArray(paramKey)) {
    paramKey.map(pKey => urlIns.searchParams.delete(pKey));
  } else {
    urlIns.searchParams.delete(paramKey);
  }

  if (replaceUrl && window.history.replaceState) {
    window.history.replaceState(null, '', urlIns.href);
  }

  return urlIns.href;
}

export default getMatchPathFromArray;
